module.exports = __webpack_public_path__ + "static/img/fw_gs.f39444b0.png";